import * as React from "react";
import ParagraphSup from "../../common/atom/text/paragraph_sup";
import AuthProCreateForm from "./pro_create/auth_pro_create_form";
import AuthProCreateSide from "./pro_create/auth_pro_create_side";
import {
  AuthWrapper,
  CreateFormFlex,
  CreateFormWrapper,
} from "./share/auth_share_components";

interface IProps {
  handleCallCreate: (values: any) => void;
}

const AuthProCreateComponent: React.FC<IProps> = (props) => {
  const { handleCallCreate } = props;

  return (
    <React.Fragment>
      <AuthWrapper>
        <CreateFormWrapper>
          <CreateFormFlex>
            <AuthProCreateSide />
            <AuthProCreateForm onSubmit={handleCallCreate} />
          </CreateFormFlex>
          <ParagraphSup>© 2022 Libera Inc.</ParagraphSup>
        </CreateFormWrapper>
      </AuthWrapper>
    </React.Fragment>
  );
};

export default AuthProCreateComponent;



// WEBPACK FOOTER //
// ./src/presentation/component/auth/auth_pro_create.tsx